import { PermissionsRoles } from "@/definitions/enums/permissions"
import { createDateQueryString } from "@/utils/date"

export const DEFAULT_QUERY_PARAMS = `?limit=10&offset=1`
export const FRONTEND_ROUTES = {
  MAIN: {
    label: "Dashboard",
    route: "/portal",
    permissionRoles: [PermissionsRoles.DASHBOARD_READ],
    requireSuperAdmin: false,
  },
  DEFAULTER: {
    label: "Inadimplência",
    route: `/portal/report/defaulters`,
    permissionRoles: [PermissionsRoles.DEFAULTERS_READ],
    requireSuperAdmin: false,
  },
  COMMISSIONS: {
    label: "Comissões",
    route: `/portal/report/commissions`,
    permissionRoles: [PermissionsRoles.COMMISSIONS_READ],
    requireSuperAdmin: false,
  },
  CHARGES: {
    label: "Cobranças",
    route: `/portal/charges`,
    permissionRoles: [PermissionsRoles.DEFAULTERS_CHARGE],
    requireSuperAdmin: false,
  },
  EXPORTED_REPORTS: {
    label: "Relatórios exportados",
    route: `/portal/exported-reports`,
    permissionRoles: [],
    requireSuperAdmin: false,
  },
  TRANSFER_SCHEDULE: {
    label: "Recebíveis",
    route: `/portal/transfer-schedule?${createDateQueryString()}`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  TRANSFER_SCHEDULE_RELEASES: {
    label: "Lançamentos",
    route: `/portal/transfer-schedule/releases`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  ACCESS_MANAGEMENT: {
    label: "Gestão de acessos",
    route: `/portal/access-management`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  UPLOAD: {
    label: "Upload",
    route: `/portal/upload`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  CUSTOMERS: {
    label: "Cadastro de clientes",
    route: `/portal/customers`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  BROKERS: {
    label: "Cadastro de corretoras",
    route: `/portal/brokers`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  PAY2B_CREDENTIALS: {
    label: "Credenciais Pay2B",
    route: `/portal/pay2b-credentials`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  DOMAIN_PREFERENCES: {
    label: "Preferências do Domínio",
    route: `/portal/domain-preferences`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  BROKER_DELIVERY_DASHBOARD: {
    label: "Relatórios Automáticos",
    route: `/portal/report-delivery`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  BROKER_DELIVERY_SCHEDULES: {
    label: "Relatórios Agendados",
    route: `/portal/report-delivery/schedules`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  BROKER_DELIVERY_TRANSFER_CONFIGS: {
    label: "Configurações de Transferência",
    route: `/portal/report-delivery/transfer-configs`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  BROKER_DELIVERY_PROCESS: {
    label: "Processar relatórios agendados",
    route: `/portal/report-delivery/process`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  WEBHOOKS: {
    label: "Webhooks",
    route: `/portal/webhooks`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  SSO_HANDOFF_API_KEYS: {
    label: "Chaves de API (SSO)",
    route: `/portal/sso-handoff-api-keys`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  SSO_PROVIDERS: {
    label: "Provedores (SSO)",
    route: `/portal/sso-providers`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  CHROMIUM: {
    label: "Chromium",
    route: `/portal/chromium`,
    permissionRoles: [],
    requireSuperAdmin: true,
  },
  LOGIN: {
    label: "Login",
    route: "/",
    permissionRoles: [],
    requireSuperAdmin: false,
  },
}
